.drawer-portal {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
}

.drawer-backdrop {
  position: absolute;
  inset: 0;
  background: var(--bg-overlay);
  animation: drawer-fade var(--duration-base) var(--ease-out);
  z-index: 0;
}

.drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: var(--bg-surface);
  border-left: 1px solid var(--border-default);
  width: var(--drawer-width);
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  box-shadow: -32px 0 60px -32px rgba(40, 35, 28, 0.18);
  animation: drawer-slide var(--duration-base) var(--ease-out);
}
.drawer-lg {
  width: 864px;
}

.drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-6) var(--space-6) var(--space-4);
  border-bottom: 1px solid var(--border-divider);
  background: var(--bg-surface);
}

.drawer-title {
  font-family: var(--font-serif);
  font-size: 21px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}
.drawer-subtitle {
  font-size: var(--size-small);
  color: var(--text-secondary);
  margin-top: 2px;
}

.drawer-header-actions {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

.drawer-close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  transition: background var(--duration-fast) var(--ease-out);
}
.drawer-close:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: var(--space-6);
}

.drawer-footer {
  padding: var(--space-4) var(--space-6);
  border-top: 1px solid var(--border-divider);
  background: var(--bg-surface);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

@media (max-width: 720px) {
  .drawer,
  .drawer-lg {
    width: 100vw;
  }
}

@keyframes drawer-slide {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes drawer-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
